import { FcCancel, FcImport, FcInspection, FcPositiveDynamic } from "react-icons/fc";
import { useFetchData } from "../../../hooks/useFetchData";


function OrderCard() {
  const {data} = useFetchData("mandoub/orders");
  return (
    <div className="section-card">
  <div className="df jc-sb orderdet">
    <span className='title'> طلباتك </span>
    
  </div>
  <ul className="df gap-8 box-info">
  <li className='jc-sb'>
      <span className="text">
        <p>المعاملات </p>
        <h3 className='!font-bold'>{data?.orders.length || 0}</h3>
      </span>
      <FcPositiveDynamic className='text-4xl' />
    </li>
    <li className='jc-sb'>
      <span className="text">
        <p>الطلبات المعلقة</p>
        <h3 className='!font-bold'>{data?.totals.pending || 0}</h3>
      </span>
      <FcImport className='text-4xl' />
    </li>
    <li className='jc-sb'>
      <span className="text">
        <p>الطلبات الملغاة</p>
        <h3 className='!font-bold'>{data?.totals.canceled || 0}</h3>
      </span>
      <FcCancel className='text-4xl' />
    </li>
    <li className='jc-sb'>
      <span className="text">
        <p>الطلبات المكتملة</p>
        <h3 className='!font-bold'>{data?.totals.delivered || 0}</h3>
      </span>
      <FcInspection className='text-4xl' />
    </li>
    
  </ul>
</div>

   
  )
}

export default OrderCard
